
export const LeadTab = {
    Sale : 1,
    Lease : 2,
    CallCenter: 3
}
